module.exports = __webpack_public_path__ + "img/actiebanner.23c20f3d.png";